import React, { useEffect, useState } from 'react';

import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { FormItem, FormLabel } from 'src/pages/observers/components/styles';

import type {
	IPreviewMessageInputComponent
} from 'src/pages/observers/components/PreviewMessageInput/types';
import {
	DictionaryContainer,
	PreviewMessageInputContainer
} from 'src/pages/observers/components/PreviewMessageInput/styles';
import Dictionary from 'src/pages/observers/components/PreviewMessageInput/Dictionary';
import PreviewEditor from 'src/pages/observers/components/PreviewMessageInput/PreviewEditor';

export default function PreviewMessageInput(
	{
		queryFields,
		reportQueries,
		defaultMessage,
		onMessageChange,
	}: IPreviewMessageInputComponent
) {
	const [ previewMessage, setPreviewMessage, ] = useState<string>(defaultMessage ?? '');

	useEffect(() => {
		onMessageChange && onMessageChange(previewMessage);
	}, [ previewMessage, ]);

	return (
		<FormItem>
			<FormLabel>
				{reportQueries ? '* Mensagem:' : '* Mensagem de alerta:'}
				<Tooltip
					title={reportQueries
						? 'Mensagem enviada a cada execução. Use {{ queries.<identificador>.count }} ou percorra {{ queries.<identificador>.result }} com {% for %}.'
						: 'Mensagem de alerta quando uma ocorrência for disparada.'}
				>
					<QuestionCircleOutlined
						style={{ color: 'rgba(0,0,0,0.45)', cursor: 'help', }}
					/>
				</Tooltip>
			</FormLabel>
			<PreviewMessageInputContainer>
				<PreviewEditor
					onChange={(value) => setPreviewMessage(value)}
					initialValue={previewMessage}
					sqlQuery={queryFields}
				/>
				<DictionaryContainer>
					<Dictionary queryFields={queryFields} reportQueries={reportQueries} />
				</DictionaryContainer>
			</PreviewMessageInputContainer>
		</FormItem>
	);
}
